<template>
    <form class="form-control-line m-t-40" @submit.prevent="onSubmit">
        <div class="card text-white bg-danger" v-if="errors">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <div class="form-group">
            <label for="email">Email</label>
            <input type="text" name="email" id="email" v-model.trim="email.email"
                   class="form-control form-control-line">
            <div v-if="$v.email.$error">
                <div class="text-danger" v-if="!$v.email.email.required">Email is required.</div>
                <div class="text-danger" v-if="!$v.email.email.email">Not valid email.</div>
            </div>
            <label for="info">Info</label>
            <input type="text" name="info" id="info" v-model.trim="info"
                   class="form-control form-control-line">
        </div>
        <div class="form-actions">
            <button type="submit" class="btn btn-info btn-rounded text-uppercase waves-effect waves-light m-r-5"
                    v-show="!loadingStatus">
                Save
            </button>
            <button class="btn btn-success btn-rounded text-uppercase waves-effect waves-light m-r-5" type="button"
                    disabled v-show="loadingStatus">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Loading...
            </button>
            <router-link to="/spam-emails" class="btn btn-success btn-rounded text-uppercase waves-effect waves-light">
                Back
            </router-link>
        </div>
    </form>
</template>

<script>
    import {required, email} from 'vuelidate/src/validators';
    import SpamEmailService from '../../services/SpamEmailService';

    export default {
        name: 'SpamEmailForm',
        data() {
            return {
                email: {id: null, email: ''},
                info: '',
                loadingStatus: false,
                errors: ''
            }
        },
        validations: {
            email: {email: {email, required}}
        },
        mounted() {
            if (this.$route.params.id) {
                SpamEmailService.getSpamEmail(this.$route.params.id).then(response => {
                    this.email = response.data.email;
                    this.info = response.data.info;
                    this.$emit('hidePreloader', true)
                });
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                this.loadingStatus = true;
                let submitMethod = null;
                let postData = {
                    email: this.email,
                    info: this.info
                };
                if (this.$route.params.id) {
                    submitMethod = SpamEmailService.updateSpamEmail(this.$route.params.id, JSON.stringify(postData));
                } else {
                    submitMethod = SpamEmailService.addSpamEmail(JSON.stringify(postData));
                }

                submitMethod.then(response => {
                    if (response.data.error !== undefined) {
                        this.errors = response.data.error;
                    } else {
                        switch (response.status) {
                            case 201:
                                this.$snotify.success('Email ' + response.data.trapEmailId + ' added successfully!', 'Success!!!');
                                this.$router.push({name: 'spamEmails'});
                                break;
                            case 200:
                                this.$snotify.success('Email ' + response.data.trapEmailId + ' updated successfully!', 'Success!!!');
                                this.$router.push({name: 'spamEmails'});
                                break;
                        }
                    }
                    this.loadingStatus = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>